export const SortOrders = (type, storeFrontOrders, setOrdersList) => {
    const newOrdersArray = [...storeFrontOrders];
    if (type === 'Most Recent') {
        setOrdersList(newOrdersArray.sort((a, b) => b.createdAt.localeCompare(a.createdAt)));
    } else if (type === 'Oldest') {
        setOrdersList(newOrdersArray.sort((a, b) => a.createdAt.localeCompare(b.createdAt)));
    }
};
